import { Invitation, InvitationRequest, Project } from '@bimdata/definitions/dto';
import api from './api';
import castDates from '@bimdata/client/utils/cast-dates';

async function send(projectId: string, body: InvitationRequest): Promise<Invitation> {
  const { data } = await api.post(`/project/${projectId}/invitations`, body);
  return data;
}

async function accept(projectId: string): Promise<void> {
  await api.post(`/invitations/${projectId}/accept`);
}

async function decline(projectId: string): Promise<void> {
  await api.delete(`/project/${projectId}/invitation`);
}

async function list(): Promise<Invitation[]> {
  const { data } = await api.get<Invitation[]>(`/invitations`);
  return data.map(({ project, ...rest }) => ({
    ...rest,
    project: castDates<Project>(project, [ 'created', 'updated' ])
  }));
}

export {
  send, accept, decline, list
};